import { COOKIE } from "./cookie";

export function parseQueryString(query: string) {
  const [ qStr ] = (query ? (query.charAt(0) === '?' ? query.slice(1) : query) : '').split('#');

  return qStr?.split('&').reduce((acc, str) => {
    const [ key, value ] = str.split('=');

    if (key && !Object.prototype.hasOwnProperty.call(acc, key)) {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, any>) || {};
}

export function prepareQueryString(query: string, hash?: string, cookies?: Record<COOKIE, any>) {
  // Add UTM info as query string if there is
  const utmObj = cookies?.[COOKIE.UTM];
  const queryObj = parseQueryString(query);
  const fullList = {...utmObj, ...queryObj };
  const uniqList = Object.entries(fullList).reduce((acc, [key, value]) => {
    if (key && !Object.prototype.hasOwnProperty.call(acc, key)) {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, any>);

  const queryString = Object.entries(uniqList).reduce((acc, [key, value]) => {
    acc.push(`${key}=${value}`)
    return acc;
  }, [] as string[]).join('&').split('#')[0];

  return (queryString ? `?${queryString}` : '') + (hash ? `#${hash}` : '') ;
}
